import React from 'react';
import Entry from '../entry';
import { Flex, Text } from 'rebass';
import { useStaticQuery, graphql } from "gatsby"
import Img from "gatsby-image"

export default () => {
  const title = '3. Windows Log Analysis: Evaluate Attack Outcome';
  const flag = 'supatree';
  const hints = [(<Flex flexDirection='row' flexWrap='wrap'><Text mr={2}>[Bushy Evergreen] </Text><a rel="noopener noreferrer" target="_blank" href="https://www.ericconrad.com/2016/09/deepbluecli-powershell-module-for-hunt.html">Deep Blue CLI Posting</a></Flex>),
     (<Flex flexDirection='row' flexWrap='wrap'><Text mr={2}>[Bushy Evergreen] </Text> <a rel="noopener noreferrer" target="_blank" href="https://github.com/sans-blue-team/DeepBlueCLI"> Deep Blue CLI on github</a></Flex>),
];
  const assignment = 'We\'re seeing attacks against the Elf U domain! Using the event log data, identify the user account that the attacker compromised using a password spray attack. Bushy Evergreen is hanging out in the train station and may be able to help you out.';
  const data = useStaticQuery(graphql`
    query {
      explicit: file(relativePath: { eq: "explicitLogons.png" }) {
        childImageSharp {
          fluid(maxWidth: 300) {
            ...GatsbyImageSharpFluid
          }
        }
      }
      failed: file(relativePath: { eq: "failedLogons.png" }) {
        childImageSharp {
          fluid(maxWidth: 300) {
            ...GatsbyImageSharpFluid
          }
        }
      }
      code3: file(relativePath: { eq: "code3.png" }) {
        childImageSharp {
          fluid(maxWidth: 400) {
            ...GatsbyImageSharpFluid
          }
        }
      }
      code3python: file(relativePath: { eq: "code3python.png" }) {
        childImageSharp {
          fluid(maxWidth: 400) {
            ...GatsbyImageSharpFluid
          }
        }
      }


    }
  `)

  return (
    <Entry
      title={title}
      hints={hints}
      flag={flag}
      assignment={assignment}
    >
      <Text my={2}>Since I do not have access to Windows VM to run Powershell, I had to replicate in Node.js what DeepBlue.ps1 did for password spraying detection.</Text>
      <Text my={2}>The first concern is transforming EVTX to JSON, so that Node.js can digest it. I took evtx2json.py from here and modified it to save JSON to 'security.json' file </Text>
      <Img fluid={data.code3python.childImageSharp.fluid}
              style={{ margin: 0,  maxHeight: '35vh', width: '70vw' }}
              imgStyle={{ objectFit: 'contain' }}
      />
      <Text my={2}>Like in DeepBlue, in our JavaScript code we will track Event ID 4648 (a logon was attempted using explicit credentials) and Event ID 4625 (account failed to log on)</Text>
      <Img fluid={data.code3.childImageSharp.fluid}
              style={{ margin: 0,  maxHeight: '60vh', width: '70vw' }}
              imgStyle={{ objectFit: 'contain' }}
      />
      <Text my={2}>We print the stats: </Text>
      <Flex flexDirection='row' justifyContent='center' alignItems='flex-start'>
        <Img fluid={data.explicit.childImageSharp.fluid}
                style={{ margin: 0,  maxHeight: '70vh', width: '35vw' }}
                imgStyle={{ objectFit: 'contain' }}
        />
        <Img fluid={data.failed.childImageSharp.fluid}
                style={{ margin: 0,  maxHeight: '70vh', width: '35vw' }}
                imgStyle={{ objectFit: 'contain' }}
        />
      </Flex>
      <Text my={2}> For user <code>supatree</code> there were 77 attempts to login, but only 76 of them failed. It means the attacker got in. </Text>
    </Entry>
  )

};
